import { render } from "./index.vue?vue&type=template&id=258ae740&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=258ae740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258ae740"],['__file',"src/components/BaseDesTable/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "258ae740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('258ae740', __exports__)) {
    api.reload('258ae740', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=258ae740&scoped=true", () => {
    api.rerender('258ae740', render)
  })

}


export default __exports__